var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.697 0.940002C12.9137 -0.313334 11.0883 -0.313334 10.305 0.940002L0.307201 16.9365C-0.525359 18.2686 0.432327 19.9965 2.0032 19.9965H21.9988C23.5697 19.9965 24.5273 18.2686 23.6948 16.9365L13.697 0.940002ZM12.0009 5.0291C12.8173 5.0291 13.3616 5.4956 13.3616 6.19535V12.0266C13.3616 12.7264 12.8173 13.1929 12.0009 13.1929C11.1846 13.1929 10.6403 12.7264 10.6403 12.0266V6.19535C10.6403 5.4956 11.1846 5.0291 12.0009 5.0291ZM10.6403 15.9143C10.6403 15.1632 11.2499 14.5536 12.0009 14.5536C12.752 14.5536 13.3616 15.1632 13.3616 15.9143C13.3616 16.6653 12.752 17.2749 12.0009 17.2749C11.2499 17.2749 10.6403 16.6653 10.6403 15.9143Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b7dd8f6a1d724aade0d0bdb50a3eb380.svg";
export { ForwardRef as ReactComponent };